import axios from 'axios';
import { createAsyncThunk, createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { appendPageable, appendQstatSearchCriteria, readPagedRows } from '../utils/spring-api';
import { serializeAxiosError, resolveAsyncThunkErrorMessage, beginReportFetch, isStaleReportRequest, isAbortedThunkError } from './reducer.utils';
const apiBase = API_ROUTES.qstat.voicemails;
const initialState = {
    loading: false,
    downloading: false,
    errorMessage: null,
    records: [],
    totalItems: 0,
    activeRequestId: null,
};
function buildParams(params) {
    const q = new URLSearchParams();
    appendPageable(q, params.page, params.size, params.sort);
    appendQstatSearchCriteria(q, {
        startDate: params.startDate,
        endDate: params.endDate,
    });
    return q;
}
export async function fetchVoicemailReportRows(params) {
    const q = buildParams(params);
    const res = await axios.get(`${apiBase}?${q.toString()}`);
    return readPagedRows(res.data, res.headers);
}
export const getVoicemailReport = createAsyncThunk('voicemail/fetch_report', async (params, { signal }) => {
    const q = buildParams(params);
    const res = await axios.get(`${apiBase}?${q.toString()}`, { signal });
    return readPagedRows(res.data, res.headers);
}, { serializeError: serializeAxiosError });
export const downloadVoicemailRecording = createAsyncThunk('voicemail/download', async (id) => axios.get(API_ROUTES.qstat.voicemailDownload(id), { responseType: 'blob' }), { serializeError: serializeAxiosError });
export const voicemailSlice = createSlice({
    name: 'voicemail',
    initialState: initialState,
    reducers: {
        clearVoicemailReport(state) {
            state.records = [];
            state.totalItems = 0;
            state.errorMessage = null;
            state.activeRequestId = null;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getVoicemailReport.fulfilled, (state, action) => {
            if (isStaleReportRequest(state, action))
                return;
            state.loading = false;
            state.records = action.payload.rows;
            state.totalItems = action.payload.total;
        })
            .addCase(downloadVoicemailRecording.fulfilled, (state) => {
            state.downloading = false;
        })
            .addMatcher(isPending(getVoicemailReport), (state, action) => {
            beginReportFetch(state, action, () => {
                state.records = [];
            });
        })
            .addMatcher(isPending(downloadVoicemailRecording), (state) => {
            state.downloading = true;
        })
            .addMatcher(isRejected(getVoicemailReport), (state, action) => {
            if (isStaleReportRequest(state, action))
                return;
            if (isAbortedThunkError(action.error))
                return;
            state.loading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        })
            .addMatcher(isRejected(downloadVoicemailRecording), (state, action) => {
            state.downloading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { clearVoicemailReport } = voicemailSlice.actions;
export default voicemailSlice.reducer;
